module.exports = __webpack_public_path__ + "static/media/shop-category-car.f4d060df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/shop-category-car.svg
// module id = 197
// module chunks = 0